import { React } from 'react';
import { useNavigate } from "react-router-dom";
import UserInfo from './UserInfo';
import { apiCallAsync } from '../apiclient';
import { User } from '../classes/User';

export default function InitUser(props) {

    const navigate = useNavigate();

    async function handleSubmit() {
        await apiCallAsync("delete", `users/${props.user.uuid}/data`,
                {data: ['new_user']})
        var usr = new User(props.user);
        delete usr.data.new_user;
        props.updateUser(usr);
        navigate("/app");
    }
    return(
        <UserInfo user={props.user} title="Welcome! Please Complete Your Registration"
                    hasSubmit={true} submitHandler={handleSubmit}
                    updateUser={props.updateUser} />
    )
}